import React from 'react';
import styled from 'styled-components';
import { CircleTick, Arrow } from 'assets/common_svgs';
import SimilarStockItemsCarousel from './similar_stock_items_carousel';

/**
 * Renders a <V2SimilarStock/> component
 * @param {Object} props
 * @param {Array} props.similarStockItems - Array items to be rendered
 * @param {Function} props.setHideSimilarStock - function to show/hide similar stock items
 * @param {Bool} props.hideSimilarStock - Bool to check if items are shown
 * @param {Bool} props.isProductDetail - Bool to check for which view the component is on
 * @param {String} props.currentStoreName - String for current location name
 * @param {String} props.currentStoreLocationId - Number for ID of current location
 * @param {String} props.tick - Image asset passed from Rails
 */

const V2SimilarStock = ({
  handleUnit,
  similarStockItems,
  setHideSimilarStock,
  hideSimilarStock,
  isProductDetail,
  currentStoreName,
  vatExclusive,
  loadingPrices,
  prices,
}) => (
  <div className="similar-stock__container mt-20">
    <div className="fl similar-stock-v2 fl-col">
      <div className="fl">
        <CircleTick
          v2ProductDetail
          fillColorMain="#207600"
          fillColorSecondary="#ffffff"
        />
        <div className="fl-1">
          <HideShow
            className="fl ai-c"
            onClick={() => setHideSimilarStock(!hideSimilarStock)}>
            {hideSimilarStock ? 'View similar items' : 'Hide similar items'}
            <Arrow fillColor="#207600" isHidden={hideSimilarStock} />
          </HideShow>
          <p>in stock at this store</p>
        </div>
      </div>
      {!hideSimilarStock && (
        <SimilarStockItemsCarousel
          handleUnit={handleUnit}
          similarStockItems={similarStockItems}
          isProductDetail={isProductDetail}
          currentStoreName={currentStoreName}
          vatExclusive={vatExclusive}
          loadingPrices={loadingPrices}
          prices={prices}
        />
      )}
    </div>
  </div>
);

const HideShow = styled.button`
  padding: 0;
  border: 0;
  background-color: transparent;
  width: 100%;
  color: #207600;
  text-align: left;
`;

export default V2SimilarStock;
